import { Box, Td, Tfoot, Tr } from '@chakra-ui/react'

import { Navigation, PageSizeSelector } from '@/components/ui'
import { getCurrentRangeMessage } from '@/utils/pageNavigation'

export interface TableFooterIProps {
  pageCount: number
  pageIndex: number
  pageSize: number
  total: number
  gotoPage: (pageIndex: number) => void
  nextPage: () => void
  onPageResize: (pageIndex: number) => void
  previousPage: () => void
  setPageSize: (pageSize: number) => void
}

export const TableFooter = ({
  pageCount,
  pageIndex,
  pageSize,
  total,
  gotoPage,
  nextPage,
  onPageResize,
  previousPage,
  setPageSize,
}: TableFooterIProps) => {
  return (
    <Tfoot bgColor='#F2F4F9'>
      <Tr>
        <Td
          alignItems='center'
          color='#2D2E41'
          display='grid'
          fontSize='14px'
          fontWeight='semibold'
          gridTemplateColumns='repeat(3, 1fr)'
          letterSpacing='-1px'
          textTransform='none'
        >
          <Box as='p'>{getCurrentRangeMessage(pageIndex, pageSize, total)}</Box>
          <Navigation
            gotoPage={gotoPage}
            nextPage={nextPage}
            pageCount={pageCount}
            pageIndex={pageIndex}
            previousPage={previousPage}
          />
          <PageSizeSelector
            onClick={onPageResize}
            pageSize={pageSize}
            setPageSize={setPageSize}
            title='Automations per page:'
          />
        </Td>
      </Tr>
    </Tfoot>
  )
}
